import { storage } from "./storage";

export const helpHttp = () => {
  const customFetch = (endpoint, options) => {
    const defaultHeader = {
      accept: "application/json",
      'Bearer': storage.get('token')
    };

    const controller = new AbortController();

    const cadena = storage.get('fechaAcceso')
    const date = cadena !== null ? new Date(cadena) : null
    var threeHour = 180 * 60 * 1000;
    const location = window.location.hash;

    options.signal = controller.signal;
    options.method = options.method || "GET";
    options.headers = options.headers
      ? { ...defaultHeader, ...options.headers }
      : defaultHeader;

    options.body = JSON.stringify(options.body) || false;

    options.mode = 'cors';

    if (!options.body) delete options.body;

    return fetch(endpoint, options)
      .then((res) => {
        if (res.ok) {
          if ((new Date() - date) < threeHour || date === null || cadena === null) {
            switch (location) {
              default:
                storage.set('fechaAcceso', new Date().toString())
                return res.json();
            }
          } else {
            window.sessionStorage.clear()
            window.location.hash = '/'
            return Promise.reject({
              err: true,
              status: res.status || "00",
              statusText: res.statusText || "Ocurrió un error"
            })

          }
        } else {
          if (res.status === 401) {
            window.sessionStorage.clear();
            window.location.hash = '/'
          } else {
            return Promise.reject({
              err: true,
              status: res.status || "00",
              statusText: res.statusText || "Ocurrió un error"
            })
          }
        }
      }
        // res.ok
        // 	? 
        //     res.json()
        // 	: 
        //     (res.status === 401 
        //       ? 
        //       (window.sessionStorage.clear(), window.location.hash('/')) //window.location.href = `/#/Signoff`
        //       :
        //         Promise.reject({
        //           err: true,
        //           status: res.status || "00",
        //           statusText: res.statusText || "Ocurrió un error",
        //         })
        //     )
      ).catch((err) => err);
  };

  const get = (url, options = {}) => customFetch(url, options);

  const post = (url, options = {}) => {
    options.method = "POST";
    return customFetch(url, options);
  };

  const put = (url, options = {}) => {
    options.method = "PUT";
    return customFetch(url, options);
  };

  const del = (url, options = {}) => {
    options.method = "DELETE";
    return customFetch(url, options);
  };

  return {
    get,
    post,
    put,
    del,
  };
};